import React from 'react';
import { FC, useEffect, useState } from 'react';
import { Typography, Grid, Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';

import WeeksTab from '../weeks-tab';
import TimeEntryTable from '../time-entry-table';
import { AppActions } from 'src/store/AppReducer';
import { RootStateType } from 'src/store/RootReducer';
import { getTimeEntryData } from 'src/services/timeManagementService';
import SnackBar from 'src/components/SnackBar/SnackBar';
import { ITimeEntry } from '../../interface/time-entry.interface';
import { TDaysOfWeeks } from '../../types/time-entry.type';
import StatusDropdown from '../status-dropdown';
import ConfirmationModal from 'src/content/common/confirmationModal/ConfirmationModal';
import { useAppSelector } from 'src/hooks/hooks';
import LoadModal from '../load-time-entry/LoadModal';
import { GetEmployeeProjectDetails } from 'src/services/projectService';
import { getAllProjects } from 'src/services/projectDetailService';
interface ITimeEntryViewProps {
  permissions: any;
  tab: string;
  id?: string;
   employeeInfo?: {
    id?: string;
    name?: string;
  };
}

type TGetTimeEntryInputProps = {
  employeeId: string;
  startDate: string;
  endDate: string;
  filter?: string[];
};

const TimeEntryView: FC<ITimeEntryViewProps> = ({ permissions, tab, id,employeeInfo}) => {
  const dispatch = useDispatch();
  const appUser = useSelector((state: RootStateType) => state.appReducer.user);
  const [snackBarOpen, setSnackBarOpen] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('');
  const [snackBarMessage, setSnackBarMessage] = React.useState('');
  const [timeEntryDetails, setTimeEntryDetails] = React.useState<ITimeEntry>();
  const [selectedStatus, setSelectedStatus] = useState<string[]>([]);
  const { isLoading } = useAppSelector((state) => state.appReducer);
  const [openConfirmationUpdate, SetOpenConfirmationUpdate] = React.useState(false);
  const [version, setVersion] = React.useState(0);
  const [childValue, setChildValue] = useState<boolean>(false);
  const [openImport, setOpenImport] = useState(false);
  const [projectList, setProjectList] = useState<any[]>([]);
  const employeeName = employeeInfo?.name;

  const rolesArray = appUser.Roles.split(',');
  const hasRole = rolesArray.includes('Super User') || rolesArray.includes('Project Manager');

  const [weekRange, setWeekRange] = useState({
    from: 3,
    to: 6
  });

  const [weekRangeSave, setWeekRangeSave] = useState({
    from: weekRange.from,
    to:weekRange.to
  });

  const getWeeksInYear = (startYear, endYear) => {
    let weeks = [];
    let weekNumber = 1;

    let date = new Date(startYear, 0, 1);

    // Adjust date to the first Monday of the year
    let day = date.getDay();
    if (day !== 1) {
      date.setDate(date.getDate() + (8 - day));
    }

    while (date.getFullYear() <= endYear) {
      let startDate = new Date(date);
      let endDate = new Date(date);
      endDate.setDate(date.getDate() + 6);

      let start = `${startDate.toLocaleString('default', {
        month: 'short'
      })} ${startDate.getDate()}`;
      let end = `${endDate.toLocaleString('default', {
        month: 'short'
      })} ${endDate.getDate()}`;

      weeks.push({
        weekNum: weekNumber,
        year: startDate.getFullYear(),
        week: `${start} - ${end}`,
        weekStartDate: startDate,
        weekEndDate: endDate
      });

      date.setDate(date.getDate() + 7);
      weekNumber++;
    }
    return weeks;
  };

  const currentYear = new Date().getFullYear();
  const weeks = getWeeksInYear(currentYear - 1, currentYear + 1);

  const currentDate = new Date();
  const dayOfWeek = currentDate.getDay();
  const diffToMonday = (dayOfWeek + 6) % 7;
  const formatDate = (date) => {
    return date.toLocaleDateString('en-CA');
  };

  let startOfWeek = new Date(currentDate);
  startOfWeek.setDate(currentDate.getDate() - diffToMonday);

  let endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(startOfWeek.getDate() + 6);

  let start = `${startOfWeek.toLocaleString('default', {
    month: 'short'
  })} ${startOfWeek.getDate()}`;
  let end = `${endOfWeek.toLocaleString('default', {
    month: 'short'
  })} ${endOfWeek.getDate()}`;

  let yearForFilter = (start.includes('Dec') && end.includes('Jan')) ? currentYear - 1 : currentYear;

  const [selectedWeek, setSelectedWeek] = useState<any>({
    weekNum: weeks.filter(
      (e) => e.week === `${start} - ${end}` && e.year === yearForFilter
    )[0].weekNum,
    year: currentYear,
    week: `${start} - ${end}`,
    weekStartDate: startOfWeek,
    weekEndDate: endOfWeek
  });

  const [selectedWeekTabs, setSelectedWeekTabs] = useState<any>({
    weekNum: weeks.filter(
      (e) => e.week === `${start} - ${end}` && e.year === yearForFilter
    )[0].weekNum,
    year: currentYear,
    week: `${start} - ${end}`,
    weekStartDate: startOfWeek,
    weekEndDate: endOfWeek
  })

  useEffect(() => {
    if (selectedWeek) {
      setWeekRange({
        from: selectedWeek?.weekNum - 1,
        to: selectedWeek?.weekNum + 2
      });

      getTimeEntryApiMethod();
    }
  }, [selectedWeek]);

  const getSelectedRange = (weekRange) => {
    let name = '';
    const filterStartSelectedDate = weeks.filter(
      (e) => e.weekNum === weekRange?.from - 2
    )[0].weekStartDate;
    const filterEndSelectedDate = weeks.filter(
      (e) => e.weekNum === weekRange?.to - 2
    )[0].weekEndDate;
    const startMonth = `${filterStartSelectedDate.getFullYear()} ${filterStartSelectedDate.toLocaleString(
      'default',
      { month: 'long' }
    )}`;
    const endMonth = `${filterEndSelectedDate.getFullYear()} ${filterEndSelectedDate.toLocaleString(
      'default',
      { month: 'long' }
    )}`;

    if (startMonth === endMonth) {
      name = startMonth;
    } else {
      name = startMonth + ' - ' + endMonth;
    }

    return name;
  };

  const getTimeEntryApiMethod = () => {
    //set get api payload
    const payload: TGetTimeEntryInputProps = {
      employeeId: id ? id : appUser.EmployeeId,
      startDate: formatDate(selectedWeek.weekStartDate),
      endDate: formatDate(selectedWeek.weekEndDate),
      filter: selectedStatus.length > 0 ? selectedStatus : null
    };

    dispatch(AppActions.showLoader());
    getTimeEntryData(payload)
      .then((response) => {
        if (response.data.statusCode === 200) {
          let data: ITimeEntry = response.data.data;

          // Function to transform the daysOfWeeks array
          const transformDaysOfWeeks = (daysOfWeeks: TDaysOfWeeks[]) => {
            return daysOfWeeks.map((day) => ({
              ...day,
              hoursWorked: day.hoursWorked ?? '0h 0m'
            }));
          };

          // Transforming projects if present
          if (data.projects && data.projects.length > 0) {
            data.projects = data.projects.map((project) => ({
              ...project,
              tasks: project.tasks.map((task) => ({
                ...task,
                daysOfWeeks: transformDaysOfWeeks(task.daysOfWeeks)
              }))
            }));
          }

          // Transforming commonTasks if present
          if (data.commonTasks && data.commonTasks.length > 0) {
            data.commonTasks = data.commonTasks.map((commonTask) => ({
              ...commonTask,
              daysOfWeeks: transformDaysOfWeeks(commonTask.daysOfWeeks)
            }));
          }
          
          setTimeEntryDetails(data);
        }
        dispatch(AppActions.hideLoader());
      })
      .catch((error) => {
        dispatch(AppActions.hideLoader());
        setSnackBarMessage('Unable to get time entry data.');
        setSnackbarSeverity('error');
        setSnackBarOpen(true);
      });
  };

  const handleStatusChange = (status: string[]) => {
    setSelectedStatus(status);
  };

  React.useEffect(() => {
    if (selectedStatus) {
      getTimeEntryApiMethod();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStatus])

  const toggleConfirmationUpdate = (e) => {
    if(childValue){
    SetOpenConfirmationUpdate(true);
    setWeekRangeSave(e)
    setVersion(0)
    setChildValue(false)
    }else{
      setWeekRange(e)
    }
  };

  const toggleConfirmationNoUpdate = () => {
    SetOpenConfirmationUpdate(false);
    setWeekRange(weekRangeSave)
    setVersion(0)
  };

  const updateTask = () => {
    setWeekRange(weekRangeSave)
    SetOpenConfirmationUpdate(false)
    setVersion(version+1)
    setChildValue(false)
  }

  const handleValueFromChild = (value: boolean) => {
    setChildValue(value);  // Update the state with the value from the child
  };

  const checkSelectedWeek = (e) =>{
    if(childValue){
      SetOpenConfirmationUpdate(true);
      setSelectedWeekTabs(e)
      setVersion(0)
      setChildValue(false)
    }
    else{
      setSelectedWeek(e)
    }
  }

  const toggleConfirmationNoUpdateTab = () =>{
    SetOpenConfirmationUpdate(false);
    setSelectedWeek(selectedWeekTabs)
    setVersion(0)
    setChildValue(false)
  }

  const updateTaskTab = () => {
    setSelectedWeek(selectedWeekTabs)
    SetOpenConfirmationUpdate(false)
    setVersion(version+1)
    setChildValue(false)
  }

  const toggleImport = () => {
    setOpenImport(!openImport);
  };

  useEffect(() => {
    const fetchProject = () => {
      if(appUser.Roles.split(',').includes('Super User')){
        getAllProjects().then((res) => {
          const filteredProjects = res.data;
          const newData = [];

          for(let i=0; i < filteredProjects.length; i++){
            newData.push({
              projectId: filteredProjects[i]?.id,
              projectName: filteredProjects[i]?.name,
              isClosed: filteredProjects[i]?.isClosed,
            });
          }
          setProjectList(newData.filter(e => !e.isClosed));
        });
      } else {
        GetEmployeeProjectDetails(appUser?.EmployeeId).then((res) => {
          const currentDate = new Date();
          let filteredRanges = res?.data?.filter(range => {
            const start = new Date(range.startDate);
            const end = new Date(range.endDate);
            return currentDate < end && currentDate > start;
          });
  
          let newFilteredRanges = filteredRanges.filter(e => e.role === "Project Manager");
          newFilteredRanges = newFilteredRanges.reduce((acc, item) => {
              if(!acc.includes(e => e.projectCode === item.projectCode)){
                acc.push(item)
              }
              return acc;
            },[]);
  
          setProjectList((newFilteredRanges.filter(e => !e.isClosed) as any[]) || []);
        });
      }
    }

    fetchProject();
  }, []);

  return (
    <div className="timesheet">
      <div>
        <iframe
          title="frame"
          id="my_iframe"
          style={{ display: 'none' }}
        ></iframe>
        <Grid
          container
          sx={{ mt: 2, mb: 1 }}
          justifyContent="space-between"
          className="time-entry-container"
        >
          <Grid item display="flex">
            <Typography
              style={{
                marginLeft: '0px',
                fontWeight: '700',
                fontSize: '16px',
                fontFamily:
                  'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
              }}
            >
              {employeeName ? `${employeeName}'s Timesheet` : 'Timesheet'} /
            </Typography>
            <Typography variant="subtitle2" className="sub-title">
              {' '}
              Time Entry
            </Typography>
          </Grid>
          <Grid item display="flex" alignItems="center" >
            <Grid sx={{ marginRight: '1rem'}}>
              <StatusDropdown onStatusChange={handleStatusChange} />
            </Grid>
            <Typography
              style={{
                marginLeft: '0px',
                fontWeight: '500',
                fontSize: '14px',
                fontFamily:
                  'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
              }}
            >
              {getSelectedRange(weekRange)}
            </Typography>
            {/* {hasRole && (
              <Button
                sx={{
                  mt: { xs: 2, md: 1 },
                  marginLeft: '1rem',
                  fontSize: '13px',
                  fontWeight: 'normal'
                }}
                style={{ height: '2rem',minWidth:'48px',paddingLeft:'10px',paddingRight:'10px' }}
                variant="contained"
                id="btn-handleClickOpen"
                startIcon={<FileUploadOutlinedIcon fontSize="small" />}
                onClick={toggleImport}
              >
                Import Time Entry
              </Button>
            )} */}
          </Grid>
          
        </Grid>
      </div>
      <div>
        <WeeksTab
          weeksList={weeks}
          // setWeek={(e) => setSelectedWeek(e)}
          setWeek={(e) =>checkSelectedWeek(e)}
          week={selectedWeek}
          // setWeekRange={(e) => setWeekRange(e)} 
          setWeekRange={(e)=>{ 
            toggleConfirmationUpdate(e);
          }}
          weekRange={weekRange}
        />
        <TimeEntryTable
          week={selectedWeek}
          year={selectedWeek?.year}
          timeEntryData={timeEntryDetails}
          getTimeEntryApiMethod={getTimeEntryApiMethod}
          version={version}
          sendValueToParent={handleValueFromChild}
          childValue={childValue}
        />
      </div>
      <SnackBar
        snackBarOpen={snackBarOpen}
        setSnackBarOpen={setSnackBarOpen}
        snackBarMessage={snackBarMessage}
        snackbarSeverity={snackbarSeverity}
      />   
      <ConfirmationModal
        open={openConfirmationUpdate}
        toggle={toggleConfirmationUpdate}
        message={`There are unsaved changes in current time sheet. Do you want to save ?`}
        onConfirm={() => updateTask()}
        noToggle={toggleConfirmationNoUpdate}
        isLoading={isLoading}
        button1 ={'Discard'}
        button2 ={'Save'}
      />

      <ConfirmationModal
        open={openConfirmationUpdate}
        toggle={checkSelectedWeek}
        message={`There are unsaved changes in current time sheet. Do you want to save ?`}
        onConfirm={() => updateTaskTab()}
        noToggle={toggleConfirmationNoUpdateTab}
        isLoading={isLoading}
        button1 ={'Discard'}
        button2 ={'Save'}
      />
      <LoadModal
        open={openImport}
        toggle={toggleImport}
        projectList={projectList}
      />
    </div>
  );
};

export default TimeEntryView;
